import React, { useState, useEffect } from 'react';
import { Table, Form, Button, Card, Modal } from "react-bootstrap";
import { Link, useParams } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPlus, faEye, faPen, faTrash, faFilter, faSync, faCalendarCheck, faMapMarkerAlt } from '@fortawesome/free-solid-svg-icons';
import PaginatedItems from '../../../../components/administracao/Pagination';
import RequireRoles from '../../../../components/RequireRoles';
import useFetch from '../../../../hooks/useFetch';
import Swal from 'sweetalert2';

export default function GerenciarEventos() {
    const { params } = useParams();
    const { get, del } = useFetch();

    const defaultState = {
        eventos: [],
        count: 0,
        filtros: { nome_evento: "", tipo_evento: "" },
        filtroAtivo: false,
        loading: true,
        mostrarModal: false,
        registroAExcluir: {}
    };

    const [state, setState] = useState(() => defaultState);

    useEffect(() => {
        async function initialize() {
            let [eventos, count] = await buscarEventos({});
            setState(s => ({ ...s, eventos, count, loading: false }));
        }
        initialize();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [params]);

    async function buscarEventos(filtros) {
        let query = "?";
        if (filtros && Object.keys(filtros).length > 0) {
            for (const key in filtros) {
                if (filtros[key] !== "") query = query.concat(key, "=", filtros[key], "&");
            }
        }
        try {
            let response = await get('/eventodocumentado' + query);
            if (response.ok) {
                let dados = response.result;
                return [dados.data, dados.count];
            }
            return [[], 0];
        } catch (error) {
            console.error('Erro no buscarEventos():', error);
            return [[], 0];
        }
    }

    async function handlePageChange(pageNumber) {
        window.scrollTo(0, 0);
        let filtros = state.filtroAtivo ? { ...state.filtros, page: pageNumber } : { page: pageNumber };
        let [eventos, count] = await buscarEventos(filtros);
        setState({ ...state, eventos, count, loading: false });
    }

    const filtrarLocal = async () => {
        let [eventos, count] = await buscarEventos(state.filtros);
        setState(s => ({ ...s, eventos, count, filtroAtivo: true, loading: false }));
    };

    const limparFiltros = async () => {
        let [eventos, count] = await buscarEventos({});
        setState(s => ({ ...s, filtros: defaultState.filtros, eventos, count, filtroAtivo: false, loading: false }));
    };

    async function excluirEvento() {
        try {
            let response = await del('/eventodocumentado/' + state.registroAExcluir.id_evento);
            if (response.status === 200) {
                let [eventos, count] = await buscarEventos(state.filtroAtivo ? state.filtros : {});
                setState({ ...state, eventos, count, mostrarModal: false, registroAExcluir: {}, loading: false });
            } else if (response.status === 409) {
                setState({ ...state, mostrarModal: false });
                Swal.fire({ title: "Não foi possível excluir", text: response.result?.message ?? "", icon: "error", confirmButtonColor: "#587b7f" });
            } else {
                console.error('Erro no excluirEvento()');
                Swal.fire({ title: "Não foi possível excluir o evento", text: "Erro inesperado, tente novamente.", icon: "error", confirmButtonColor: "#587b7f" });
            }
        } catch (error) {
            console.error('Erro no excluirEvento():', error);
            Swal.fire({ title: "Erro de conexão", text: "Não foi possível falar com o servidor. Verifique sua conexão e tente novamente.", icon: "error", confirmButtonColor: "#587b7f" });
        }
    }

    return (
        <div className="admin-page-container">
            <div className="admin-header-container">
                <div className="title-group">
                    <h2 className="admin-title">Eventos Documentados</h2>
                    <p className="admin-subtitle">Contextos históricos e eventos registrados nas fotografias</p>
                </div>
                <Link to="/admin/iconografico/eventos/criar" className="btn-add-new">
                    <FontAwesomeIcon icon={faPlus} className="me-2" /> Novo Evento
                </Link>
            </div>

            <Card className="filter-card-admin mb-4">
                <Card.Body className="p-4">
                    <Form className="row g-3" onSubmit={(e) => { e.preventDefault(); filtrarLocal(); }}>
                        <Form.Group className="col-md-6">
                            <Form.Label className="label-admin">Nome do Evento</Form.Label>
                            <Form.Control
                                className="input-moderno"
                                placeholder="Ex: Inauguração da Biblioteca..."
                                value={state.filtros.nome_evento}
                                onChange={e => setState({ ...state, filtros: { ...state.filtros, nome_evento: e.target.value } })}
                            />
                        </Form.Group>
                        <Form.Group className="col-md-4">
                            <Form.Label className="label-admin">Tipo de Evento</Form.Label>
                            <Form.Select
                                className="input-moderno"
                                value={state.filtros.tipo_evento}
                                onChange={e => setState({ ...state, filtros: { ...state.filtros, tipo_evento: e.target.value } })}
                            >
                                <option value="">Todos os tipos</option>
                                <option value="Cerimônia">Cerimônia</option>
                                <option value="Congresso">Congresso</option>
                                <option value="Aula">Aula</option>
                                <option value="Visita">Visita</option>
                                <option value="Outro">Outro</option>
                            </Form.Select>
                        </Form.Group>
                        <div className="col-md-2 d-flex gap-2 align-items-end">
                            <Button type="button" className="btn-apply-filters w-100" onClick={filtrarLocal}>
                                <FontAwesomeIcon icon={faFilter} />
                            </Button>
                            <Button type="button" className="btn-clear-filters" onClick={limparFiltros}>
                                <FontAwesomeIcon icon={faSync} />
                            </Button>
                        </div>
                    </Form>
                </Card.Body>
            </Card>

            <Card className="table-card-admin">
                <div className="table-responsive">
                    <Table className="modern-table mb-0">
                        <thead>
                            <tr>
                                <th>Evento</th>
                                <th>Tipo</th>
                                <th>Período</th>
                                <th>Local</th>
                                <th className="text-center">Opções</th>
                            </tr>
                        </thead>
                        <tbody>
                            {state.loading ? (
                                <tr><td colSpan="5" className="text-center py-5"><div className="spinner-border text-teal"></div></td></tr>
                            ) : state.eventos.length > 0 ? (
                                state.eventos.map((item) => (
                                    <tr key={item.id_evento}>
                                        <td data-label="Evento" className="fw-bold">
                                            <FontAwesomeIcon icon={faCalendarCheck} className="me-2 text-muted" />
                                            {item.nome_evento}
                                        </td>
                                        <td data-label="Tipo"><span className="badge bg-light text-dark border">{item.tipo_evento || '-'}</span></td>
                                        <td data-label="Período" className="small text-muted">
                                            {item.data_inicio ? new Date(item.data_inicio).toLocaleDateString('pt-BR') : '-'}
                                            {item.data_fim ? ` - ${new Date(item.data_fim).toLocaleDateString('pt-BR')}` : ''}
                                        </td>
                                        <td data-label="Local" className="small">
                                            <FontAwesomeIcon icon={faMapMarkerAlt} className="me-1 text-teal" />
                                            {item.local_evento || '-'}
                                        </td>
                                        <td data-label="Opções">
                                            <div className="d-flex justify-content-center gap-2">
                                                <Link className="action-icon view" to={`/admin/iconografico/eventos/${item.id_evento}`} state={{ acao: "Visualizar" }}><FontAwesomeIcon icon={faEye} /></Link>
                                                <Link className="action-icon edit" to={`/admin/iconografico/eventos/${item.id_evento}`} state={{ acao: "Editar" }}><FontAwesomeIcon icon={faPen} /></Link>
                                                <RequireRoles allowedRoles={['Desenvolvedor', 'Administrador']}>
                                                    <button className="action-icon delete" onClick={() => setState({ ...state, mostrarModal: true, registroAExcluir: item })}><FontAwesomeIcon icon={faTrash} /></button>
                                                </RequireRoles>
                                            </div>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="5" className="text-center py-4 text-muted">Nenhum evento encontrado.</td></tr>
                            )}
                        </tbody>
                    </Table>
                </div>
                {state.eventos.length > 0 && (
                    <div className="card-footer bg-white border-0 py-3 d-flex justify-content-center">
                        <PaginatedItems itemCount={state.count} itemsPerPage={20} handlePageChange={handlePageChange} />
                    </div>
                )}
            </Card>

            <Modal show={state.mostrarModal} onHide={() => setState({ ...state, mostrarModal: false })} centered className="modern-modal">
                <Modal.Header closeButton className="modal-header-teal">
                    <Modal.Title className="text-white fs-5">Excluir Evento</Modal.Title>
                </Modal.Header>
                <Modal.Body className="p-4">
                    <p className="mb-0">Deseja excluir o evento <strong>{state.registroAExcluir.nome_evento}</strong>?</p>
                </Modal.Body>
                <Modal.Footer className="border-0 p-4 pt-0">
                    <Button variant="light" onClick={() => setState({ ...state, mostrarModal: false })}>Cancelar</Button>
                    <Button variant="danger" className="px-4" onClick={excluirEvento}>Confirmar</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}
